export const CONST_STATUS_TAREFA: { label: string; value: number }[] = [
  { label: 'Atrasada', value: 1 },
  { label: 'No prazo', value: 2 },
  { label: 'Finalizada', value: 3 },
  { label: 'Finalizado c/ atraso', value: 4 }
];
